<template>
    <div :class="[cols ? 'col-' + cols : '', xs ? 'col-xs-' + xs : '', sm ? 'col-sm-' + sm : '', md ? 'col-md-' + md : '', lg ? 'col-lg-' + lg : '', xl ? 'col-xl-' + xl : '']">
        <slot/>
    </div>
</template>

<script>
export default {
        name: "Column",

        props: {
            cols: {
                type: [Number, String],
                default: null
            },

            xs: {
                type: [Number, String],
                default: null
            },

            sm: {
                type: [Number, String],
                default: null
            },

            md: {
                type: [Number, String],
                default: null
            },

            lg: {
                type: [Number, String],
                default: null
            },

            xl: {
                type: [Number, String],
                default: null
            },
        }
    }
</script>

<style>
[class*=col-] {
  grid-row: auto;
  min-width: 0;
}

.col-0 {
  grid-column-start: auto;
  grid-column-end: span 0;
}

.col-1 {
  grid-column-start: auto;
  grid-column-end: span 1;
}

.col-2 {
  grid-column-start: auto;
  grid-column-end: span 2;
}

.col-3 {
  grid-column-start: auto;
  grid-column-end: span 3;
}

.col-4 {
  grid-column-start: auto;
  grid-column-end: span 4;
}

.col-5 {
  grid-column-start: auto;
  grid-column-end: span 5;
}

.col-6 {
  grid-column-start: auto;
  grid-column-end: span 6;
}

.col-7 {
  grid-column-start: auto;
  grid-column-end: span 7;
}

.col-8 {
  grid-column-start: auto;
  grid-column-end: span 8;
}

.col-9 {
  grid-column-start: auto;
  grid-column-end: span 9;
}

.col-10 {
  grid-column-start: auto;
  grid-column-end: span 10;
}

.col-11 {
  grid-column-start: auto;
  grid-column-end: span 11;
}

.col-12 {
  grid-column-start: auto;
  grid-column-end: span 12;
}

@media (min-width: 0px) {
  .col-xs-0 {
    grid-column-start: auto;
    grid-column-end: span 0;
  }
  .col-xs-1 {
    grid-column-start: auto;
    grid-column-end: span 1;
  }
  .col-xs-2 {
    grid-column-start: auto;
    grid-column-end: span 2;
  }
  .col-xs-3 {
    grid-column-start: auto;
    grid-column-end: span 3;
  }
  .col-xs-4 {
    grid-column-start: auto;
    grid-column-end: span 4;
  }
  .col-xs-5 {
    grid-column-start: auto;
    grid-column-end: span 5;
  }
  .col-xs-6 {
    grid-column-start: auto;
    grid-column-end: span 6;
  }
  .col-xs-7 {
    grid-column-start: auto;
    grid-column-end: span 7;
  }
  .col-xs-8 {
    grid-column-start: auto;
    grid-column-end: span 8;
  }
  .col-xs-9 {
    grid-column-start: auto;
    grid-column-end: span 9;
  }
  .col-xs-10 {
    grid-column-start: auto;
    grid-column-end: span 10;
  }
  .col-xs-11 {
    grid-column-start: auto;
    grid-column-end: span 11;
  }
  .col-xs-12 {
    grid-column-start: auto;
    grid-column-end: span 12;
  }
}
@media (min-width: 640px) {
  .col-sm-0 {
    grid-column-start: auto;
    grid-column-end: span 0;
  }
  .col-sm-1 {
    grid-column-start: auto;
    grid-column-end: span 1;
  }
  .col-sm-2 {
    grid-column-start: auto;
    grid-column-end: span 2;
  }
  .col-sm-3 {
    grid-column-start: auto;
    grid-column-end: span 3;
  }
  .col-sm-4 {
    grid-column-start: auto;
    grid-column-end: span 4;
  }
  .col-sm-5 {
    grid-column-start: auto;
    grid-column-end: span 5;
  }
  .col-sm-6 {
    grid-column-start: auto;
    grid-column-end: span 6;
  }
  .col-sm-7 {
    grid-column-start: auto;
    grid-column-end: span 7;
  }
  .col-sm-8 {
    grid-column-start: auto;
    grid-column-end: span 8;
  }
  .col-sm-9 {
    grid-column-start: auto;
    grid-column-end: span 9;
  }
  .col-sm-10 {
    grid-column-start: auto;
    grid-column-end: span 10;
  }
  .col-sm-11 {
    grid-column-start: auto;
    grid-column-end: span 11;
  }
  .col-sm-12 {
    grid-column-start: auto;
    grid-column-end: span 12;
  }
}
@media (min-width: 768px) {
  .col-md-0 {
    grid-column-start: auto;
    grid-column-end: span 0;
  }
  .col-md-1 {
    grid-column-start: auto;
    grid-column-end: span 1;
  }
  .col-md-2 {
    grid-column-start: auto;
    grid-column-end: span 2;
  }
  .col-md-3 {
    grid-column-start: auto;
    grid-column-end: span 3;
  }
  .col-md-4 {
    grid-column-start: auto;
    grid-column-end: span 4;
  }
  .col-md-5 {
    grid-column-start: auto;
    grid-column-end: span 5;
  }
  .col-md-6 {
    grid-column-start: auto;
    grid-column-end: span 6;
  }
  .col-md-7 {
    grid-column-start: auto;
    grid-column-end: span 7;
  }
  .col-md-8 {
    grid-column-start: auto;
    grid-column-end: span 8;
  }
  .col-md-9 {
    grid-column-start: auto;
    grid-column-end: span 9;
  }
  .col-md-10 {
    grid-column-start: auto;
    grid-column-end: span 10;
  }
  .col-md-11 {
    grid-column-start: auto;
    grid-column-end: span 11;
  }
  .col-md-12 {
    grid-column-start: auto;
    grid-column-end: span 12;
  }
}
@media (min-width: 1024px) {
  .col-lg-0 {
    grid-column-start: auto;
    grid-column-end: span 0;
  }
  .col-lg-1 {
    grid-column-start: auto;
    grid-column-end: span 1;
  }
  .col-lg-2 {
    grid-column-start: auto;
    grid-column-end: span 2;
  }
  .col-lg-3 {
    grid-column-start: auto;
    grid-column-end: span 3;
  }
  .col-lg-4 {
    grid-column-start: auto;
    grid-column-end: span 4;
  }
  .col-lg-5 {
    grid-column-start: auto;
    grid-column-end: span 5;
  }
  .col-lg-6 {
    grid-column-start: auto;
    grid-column-end: span 6;
  }
  .col-lg-7 {
    grid-column-start: auto;
    grid-column-end: span 7;
  }
  .col-lg-8 {
    grid-column-start: auto;
    grid-column-end: span 8;
  }
  .col-lg-9 {
    grid-column-start: auto;
    grid-column-end: span 9;
  }
  .col-lg-10 {
    grid-column-start: auto;
    grid-column-end: span 10;
  }
  .col-lg-11 {
    grid-column-start: auto;
    grid-column-end: span 11;
  }
  .col-lg-12 {
    grid-column-start: auto;
    grid-column-end: span 12;
  }
}
@media (min-width: 1280px) {
  .col-xl-0 {
    grid-column-start: auto;
    grid-column-end: span 0;
  }
  .col-xl-1 {
    grid-column-start: auto;
    grid-column-end: span 1;
  }
  .col-xl-2 {
    grid-column-start: auto;
    grid-column-end: span 2;
  }
  .col-xl-3 {
    grid-column-start: auto;
    grid-column-end: span 3;
  }
  .col-xl-4 {
    grid-column-start: auto;
    grid-column-end: span 4;
  }
  .col-xl-5 {
    grid-column-start: auto;
    grid-column-end: span 5;
  }
  .col-xl-6 {
    grid-column-start: auto;
    grid-column-end: span 6;
  }
  .col-xl-7 {
    grid-column-start: auto;
    grid-column-end: span 7;
  }
  .col-xl-8 {
    grid-column-start: auto;
    grid-column-end: span 8;
  }
  .col-xl-9 {
    grid-column-start: auto;
    grid-column-end: span 9;
  }
  .col-xl-10 {
    grid-column-start: auto;
    grid-column-end: span 10;
  }
  .col-xl-11 {
    grid-column-start: auto;
    grid-column-end: span 11;
  }
  .col-xl-12 {
    grid-column-start: auto;
    grid-column-end: span 12;
  }
}
</style>